type AlertType = 'success' | 'error' | 'info' | 'warning';

interface InlineAlertProps {
  type?: AlertType;
  message: string;
  onClose?: () => void;
  className?: string;
}

const typeStyles: Record<AlertType, { container: string; icon: string; label: string }> = {
  success: {
    container: 'bg-green-50 border-green-200 text-green-800',
    icon: 'text-green-500',
    label: 'Éxito'
  },
  error: {
    container: 'bg-red-50 border-red-200 text-red-800',
    icon: 'text-red-500',
    label: 'Error'
  },
  info: {
    container: 'bg-blue-50 border-blue-200 text-blue-800',
    icon: 'text-blue-500',
    label: 'Info'
  },
  warning: {
    container: 'bg-yellow-50 border-yellow-200 text-yellow-800',
    icon: 'text-yellow-600',
    label: 'Aviso'
  }
};

export default function InlineAlert({ type = 'info', message, onClose, className = '' }: InlineAlertProps) {
  const styles = typeStyles[type];

  return (
    <div className={`flex items-start gap-3 border rounded-lg p-3 ${styles.container} ${className}`}>
      <span className={`${styles.icon}`}>⚑</span>
      <div className="flex-1">
        <div className="font-semibold">{styles.label}</div>
        <div className="text-sm">{message}</div>
      </div>
      {onClose && (
        <button
          aria-label="Cerrar"
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700"
        >
          ×
        </button>
      )}
    </div>
  );
}
